import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Save } from "lucide-react";

export default function AdminPricing() {
  const [pricing, setPricing] = useState({ unit_price_standard: 3500, unit_price_professional: 5500, currency: "TL" });
  useEffect(() => {
    let cancelled = false;
    api.get("/pricing")
      .then((r) => { if (!cancelled) setPricing((prev) => ({ ...prev, ...r.data })); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const save = async () => {
    try {
      await api.put("/pricing", pricing);
      toast.success("Fiyatlandırma kaydedildi");
    } catch { toast.error("Kayıt hatası"); }
  };

  return (
    <div data-testid="admin-pricing">
      <h1 className="font-display text-3xl md:text-4xl font-black text-ink-900 mb-8">Fiyatlandırma</h1>
      <div className="rounded-3xl bg-white border border-ink-100 p-8 max-w-2xl space-y-5">
        <div>
          <Label className="text-xs uppercase tracking-widest font-bold">Standart m² Birim Fiyat</Label>
          <Input data-testid="pricing-standard" type="number" step="any" value={pricing.unit_price_standard} onChange={(e) => setPricing({ ...pricing, unit_price_standard: Number(e.target.value) })} className="mt-1.5" />
        </div>
        <div>
          <Label className="text-xs uppercase tracking-widest font-bold">Profesyonel m² Birim Fiyat</Label>
          <Input data-testid="pricing-professional" type="number" step="any" value={pricing.unit_price_professional} onChange={(e) => setPricing({ ...pricing, unit_price_professional: Number(e.target.value) })} className="mt-1.5" />
        </div>
        <div>
          <Label className="text-xs uppercase tracking-widest font-bold">Para Birimi</Label>
          <Input value={pricing.currency} onChange={(e) => setPricing({ ...pricing, currency: e.target.value })} className="mt-1.5" />
        </div>
        <Button onClick={save} data-testid="pricing-save" className="gradient-primary text-white rounded-full"><Save className="h-4 w-4 mr-1.5" /> Kaydet</Button>
      </div>
    </div>
  );
}
